export const translations = {
  DE: {
    metaDescription:
      'Konfigurieren Sie Ihr eigenes [ui!] COCKPIT passend zu den Bedürfnissen Ihrer Kommune. Wählen Sie aus einer großen Anzahl an Kacheln und starten Sie noch heute mit dem [ui!] COCKPIT und der Datenplattform [ui!] UrbanPulse!',
    catalogueIntroTitle: 'Über das [ui!] COCKPIT',
    catalogueIntroSubTitle: 'Was ist das [ui!] COCKPIT?',
    catalogueIntroContent: `Visualisierung von Informationen sind die Grundlage für Mehrwerte einer Stadt.
      
    Eine digitale Stadt ist ein durchaus komplexes Thema und betrifft mehrere Bereiche zugleich. Hier fehlt oftmals die Möglichkeit, ein Gesamtbild vor Augen zu haben.

    Mit einer ansprechenden und leicht verständlichen Visualisierung von Schlüsselindikatoren zu Smart City Themen ist die Information und der Austausch mit den Bürgerinnen und Bürger sehr einfach und Entscheidungsträgern werden weitreichendere Einblicke in die urbane Infrastruktur mit all ihren Daten ermöglicht.`,
    catalogueIntroSubTitle2: 'Wofür kann ich den Kachelkatalog nutzen?',
    catalogueIntroContent2: `Das [ui!] COCKPIT bietet die Möglichkeit, eine Vielzahl an Daten der Stadt darzustellen. Daten sind jedoch nicht gleich Daten – Daten zur Belegung der Parkplätze erfordern bspw. eine andere Darstellung als Messdaten von Umweltsensoren.
    
      Deshalb gibt es einen großen Katalog aus Kacheln, die für die Anzeige der jeweiligen Daten speziell angefertigt und optimiert sind. Sie können aus diesen Kacheln frei wählen und sich so hoch individuell ein eigenes [ui!] COCKPIT nach Ihren Bedürfnissen zusammenstellen, das die Themen Ihrer Smart City perfekt widerspiegelt.
      `,
    cockpit: 'COCKPIT',
    currentVersion: 'Stand',
    changeAppearanceTutorial: `Ich möchte das Aussehen des [ui!] COCKPITs ändern`,
    close: 'Schliessen',
    cockpitConfigurator: 'COCKPIT Konfigurator',
    changeTheme: 'Design wechseln',
    changeLanguage: 'Sprache ändern',
    dataProtection: 'Datenschutz',
    dark: 'Dunkel',
    generateCatalogue: 'Katalog erstellen',
    doNotShowAgain: `Dieses Fenster nicht mehr anzeigen`,
    Energie: 'Energie',
    end: `Beenden`,
    exportConfig: 'Exportiere Konfiguration (JSON)',
    fillTilesTutorial: `Ich möchte das [ui!] COCKPIT mit Kacheln befüllen`,
    from: `von`,
    further: `Weiter`,
    Finanzen: 'Finanzen',
    importConfig: 'Importiere Konfiguration (JSON)',
    Infrastruktur: 'Infrastruktur',
    imprint: 'Impressum',
    light: 'Hell',
    Mobilität: 'Mobilität',
    premiumTile: `Premium Kachel`,
    resetToDefault: 'Zurücksetzen',
    saveConfigTutorial: `Ich möchte das erstellte [ui!] COCKPIT für später speichern und zurücksetzen`,
    SmartLighting: 'Smart Lighting',
    Sonstiges: 'Sonstiges',
    startTutorialAgain: 'Tutorial Erneut Starten',
    step: `Schritt`,
    tutorialIntro: `Für die Nutzung des [ui!] COCKPIT Konfigurators stellen wir Ihnen einige Tutorials zur Verfügung. Folgende Optionen haben wir für Sie vorbereitet:`,
    theme: 'thema',
    combinedLightTheme: 'Helles Design',
    combinedDarkTheme: 'Dunkel Design',
    tocTitle: 'Inhalt',
    tiles: 'Kacheln',
    tileCatalogue: 'Kachelkatalog',
    Umwelt: 'Umwelt',
    upgradeLink: `Diese Kachel ist nur in der Vollversion des [ui!] COCKPIT enthalten. Um auf die Vollversion upzugraden folgen Sie bitte diesem`,
    welcomeTo: 'Willkommen zum',
    welcomeToTheConfiguratorFor: 'Willkommen Zum Konfigurator für'
  },
  EN: {
    metaDescription:
      'Configure your [ui!] COCKPIT to meet the needs of your city. Pick from a huge number of tiles and start with your [ui!] COCKPIT and [ui!] UrbanPulse installation today!',
    catalogueIntroTitle: 'About the [ui!] COCKPIT',
    catalogueIntroSubTitle: 'What is the [ui!] COCKPIT?',
    catalogueIntroContent: `Visualisation of information is crucial for enhancing a city's value. A digital city is a complex entity, often lacking a clear, overall picture. 
    
    By introducing clear and engaging visualizations of key smart city indicators, information sharing with citizens becomes simpler, and decision-makers gain deeper insights into urban infrastructure. This approach makes interpreting vast city data more accessible, aiding more informed decision-making.
      `,
    catalogueIntroSubTitle2: 'What can I use the tile catalogue for?',
    catalogueIntroContent2: `The [ui!] COCKPIT offers the possibility to display a wide range of data of the city. However, not all data is the same - data on the occupancy of parking spaces, for example, requires a different visualization than measurement data from environmental sensors.
      
    Therefore, there is a large catalog of tiles, which are specially made and optimized for the display of the respective data. You can choose freely from these tiles and thus create a highly individual [ui!] COCKPIT according to your needs, which perfectly reflects the topics of your Smart City.
      `,
    cockpit: 'COCKPIT',
    currentVersion: 'Version',
    changeAppearanceTutorial: `I want to change the appearance of the [ui!] COCKPIT`,
    close: `Close`,
    cockpitConfigurator: 'COCKPIT Configurator',
    changeTheme: 'Change Theme',
    changeLanguage: 'Change Language',
    dataProtection: 'Data protection',
    dark: 'Dark',
    generateCatalogue: 'Generate Catalogue',
    doNotShowAgain: `Do not show this window again`,
    Energie: 'Energy',
    end: `End`,
    exportConfig: 'Export configuration (JSON)',
    fillTilesTutorial: `I want to fill the [ui!] COCKPIT with tiles`,
    from: `from`,
    further: `next`,
    Finanzen: 'Finances',
    importConfig: 'Import configuration (JSON)',
    Infrastruktur: 'Infrastructure',
    imprint: 'Imprint',
    light: 'Light',
    Mobilität: 'Mobility',
    premiumTile: `Premium Tile`,
    resetToDefault: 'Reset to default',
    saveConfigTutorial: `I want to save the created [ui!] COCKPIT for later and reset`,
    SmartLighting: 'Smart Lighting',
    Sonstiges: 'Miscellaneous',
    startTutorialAgain: 'Start tutorial again',
    step: `Step`,
    tutorialIntro: `To utilize the [ui!] COCKPIT configurator, we have provided a selection of tutorials for your convenience. Here are the options we've prepared for you:`,
    theme: 'theme',
    combinedLightTheme: 'Light Design',
    combinedDarkTheme: 'Dark Design',
    tocTitle: 'Contents',
    tiles: 'tiles',
    tileCatalogue: 'tile catalogue',
    Umwelt: 'Environment',
    upgradeLink: `This tile is only included in the full version of [ui!] COCKPIT. Around to upgrade to the full version please follow this`,
    welcomeTo: `Welcome to`,
    welcomeToTheConfiguratorFor: 'Welcome to the Configurator for'
  }
};
